// QueueFooter — stopka stanu kolejki (V3 słaby zasięg B-1, UZUPEŁNIENIE 2, decyzja Martina 12.09.2026).
//
// Jedna cienka linia na dole KAŻDEGO ekranu po zalogowaniu, pod treścią (widoczna po przewinięciu
// na sam dół), bez interakcji:
//   „⏳ 7 zdjęć czeka · ostatnie wysłane 40 s temu"
//   „✓ wszystko wysłane · ostatnie 3 min temu"       (pusta kolejka)
//   „🔒 Tryb lokalny · 7 zdjęć na telefonie"          (B9)
// Czas względny odświeżany co 30 s. Pełne dane (rejestr prób, MB) zostają w Serwisie.
// Renderowana w App.jsx po komponencie ekranu (poza jego kontenerem), więc nie zależy od
// układu poszczególnych ekranów.

import { useEffect, useState } from 'react';
import { useOffline } from '../../hooks/useOffline.js';
import { isLocalMode, subscribeLocalMode } from '../../services/localMode.js';
import { footerStatus, getLastSuccessAt, subscribeQueueHealth, HEALTH_TICK_MS } from '../../services/queueHealth.js';
import { TOKENS } from '../../shared/tokens.js';
// B-1b (F7, 13.09.2026): etykieta urządzenia doklejona na początku linii („D.Tyrek #2 · ✓ wszystko
// wysłane · …"; przy własnej nazwie „Samsung Kamila · …") — identyfikacja telefonu bez Serwisu.
import { getFleetState, subscribeFleet } from '../../services/fleet.js';
// MONIT 2026-10-02_0526: stopka re-renderuje się po zmianie języka (footerStatus czyta i18n).
import { useLang } from '../../hooks/useLang.js';

export default function QueueFooter() {
  useLang();
  const { queueStats } = useOffline();
  const [fleet, setFleet] = useState(() => getFleetState());
  useEffect(() => subscribeFleet(setFleet), []);
  const deviceLabel = fleet?.label?.display || null;
  const [localMode, setLocalModeState] = useState(isLocalMode());
  useEffect(() => subscribeLocalMode(setLocalModeState), []);
  const [lastSuccessAt, setLastSuccessAt] = useState(() => getLastSuccessAt());
  useEffect(() => subscribeQueueHealth(setLastSuccessAt), []);
  const [, setTick] = useState(0);
  useEffect(() => {
    const t = setInterval(() => setTick((x) => x + 1), HEALTH_TICK_MS);
    return () => clearInterval(t);
  }, []);

  const st = footerStatus({ localMode, stats: queueStats, lastSuccessAt, now: Date.now() });

  return (
    <div
      role="contentinfo"
      data-queue-footer={st.kind}
      data-device-label={deviceLabel || undefined}
      style={{
        width: '100%', maxWidth: TOKENS.layout.maxWidth, margin: '0 auto',
        boxSizing: 'border-box',
        padding: '7px 12px calc(7px + env(safe-area-inset-bottom, 0px))',
        fontSize: 11, lineHeight: 1.3, fontFamily: TOKENS.font.mono,
        color: st.kind === 'local' ? 'var(--fo-yellow, #eab308)' : TOKENS.colors.textMuted,
        background: TOKENS.colors.bgMain,
        borderTop: `1px solid ${TOKENS.colors.border}`,
        textAlign: 'center', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis',
        userSelect: 'none', WebkitUserSelect: 'none', pointerEvents: 'none',
        position: 'relative', zIndex: 5,
      }}
    >
      {deviceLabel ? `${deviceLabel} · ${st.text}` : st.text}
    </div>
  );
}
